// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getEmptyImage(param) {
  return {
          path: "",
          alt_text: ""
        };
}

function getImage(model) {
  return {
          path: model.data.attributes.url,
          alt_text: Belt_Option.getWithDefault(model.data.attributes.alternativeText, model.data.attributes.name)
        };
}

function getImageFromSingleImage(model) {
  return {
          path: model.image.data.attributes.url,
          alt_text: model.alt_text
        };
}

function getImageEntity(model) {
  return {
          path: model.image.url,
          alt_text: model.alt_text
        };
}

function getOptionalImage(model) {
  var image = model.data;
  if (image !== undefined) {
    return getImage({
                data: image
              });
  } else {
    return {
            path: "",
            alt_text: ""
          };
  }
}

function getImageFromLongImage(model) {
  return {
          path: model.src_path.data.attributes.url,
          alt_text: model.alt_text
        };
}

function getImageFromShortImage(model) {
  return {
          path: model.src_path.url,
          alt_text: model.alt_text
        };
}

export {
  getEmptyImage ,
  getImage ,
  getImageFromSingleImage ,
  getImageEntity ,
  getOptionalImage ,
  getImageFromLongImage ,
  getImageFromShortImage ,
}
/* No side effect */
